<template>
    <div>
        <span role="alert" class="error" v-if="isBadContact">
            <font-awesome-icon
                :icon="['far', 'triangle-exclamation']"
                class="text-xl mr-2 relative"
                @mouseenter="showTooltip=true"
                @mouseleave="showTooltip=false"
            />
                <div id="tooltip-default" role="tooltip" class="absolute z-10 py-1 px-3 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm transition-opacity duration-300 tooltip"
                    :class="{'hidden' : !showTooltip}"
                >
                    {{badContactReason}}
                </div>
        </span>
        <span v-if="data.message_tra_id">
          <Link v-if="!data.error_message" :href="route('message.details', data.message_tra_id)" class="text-blue-600">
            {{ recipientName }}
          </Link>
          <span v-else>{{ data.recipient_name }}</span>
        </span>
        <Link v-else :href="route('contacts.view', data.id)" class="text-blue-600">
          {{ data.first_name }}
        </Link>
    </div>

</template>


<script>

export default {
    name: 'ContactTableName',
    props: ['data'],
    data: () => ({
        showTooltip: false,
    }),
    computed: {
        isBadContact() {
            return (
                this.data.bad_contact ||
                this.data.do_not_contact
            )
        },
        badContactReason() {
            if(this.data.do_not_contact) {
                return "Contact has opted out";
            }
            if (this.data.bad_contact) {

                if (
                    this.data.bad_contact_reason.includes("not a valid phone number") ||
                    this.data.bad_contact_reason.includes("not a mobile number")

                ) {
                    return "The phone number is not a mobile phone number.";
                }
                if (
                    this.data.bad_contact_reason.includes("unsubscribed") ||
                    this.data.bad_contact_reason.includes("blacklist")
                ) {
                    return "Contact unsubscribed .";
                }

                if (this.data.bad_contact_reason.includes("not been enabled for the region") ) {
                    return "Permission to send text messages is not enabled for this contact's region.";
                }

            }
        },
      recipientName() {
        if(this.data.group_id){
          if(this.data.recipient_name.deleted_at) {
            return this.data.recipient_name + ' (Deleted List)'
          } else if(this.data.recipient_name.deleted_at == null) {
            return this.data.recipient_name
          }
        } else {
          return this.data.recipient_name
        }
      }
    },
}


</script>

<style scoped>
.error {
    @apply text-red-700 px-4 py-3;
}

</style>
